export default __webpack_public_path__ + "static/media/leaf4.1eca93c7.svg";